import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-loanPicture/loanPicture/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-loanPicture/loanPicture/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-loanPicture/loanPicture/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-loanPicture/loanPicture/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-loanPicture/loanPicture/submit',
    method: 'post',
    data: row
  })
}

export const putFile = (file) => {
  return request({
    url: '/api/blade-resource/oss/endpoint/putFile',
    method: 'post',
    data: (function (file) {
      var form = new FormData();
      form.append("file", file);
      return form;
    })(file),
  })
}

